/**
 * RoleSelector
 *
 * Chip-based role picker for AI reference images.
 * Shared above tabs in AssetPickerModal.
 *
 * Built with Tailwind CSS v4.1 and V2 components.
 */

import { Button } from '@/components/v2/ui';

// ============================================================================
// Types
// ============================================================================

export interface RoleOption {
  value: string;
  label: string;
  icon: string;
  color: string;
}

interface RoleSelectorProps {
  roles: RoleOption[];
  selected: string;
  onChange: (value: string) => void;
}

// ============================================================================
// Component
// ============================================================================

export function RoleSelector({ roles, selected, onChange }: RoleSelectorProps) {
  return (
    <div>
      <label className="text-sm font-medium text-neutral-900 dark:text-neutral-50 block mb-2">
        Rolle (optional)
      </label>
      <div className="flex gap-2 flex-wrap">
        {roles.map((role) =>
          selected === role.value ? (
            <ActiveRoleChip key={role.value} role={role} onDeselect={() => onChange('')} />
          ) : (
            <Button
              key={role.value}
              variant="outline"
              size="sm"
              onClick={() => onChange(role.value)}
            >
              <span className="mr-1">{role.icon}</span>
              {role.label}
            </Button>
          ),
        )}
      </div>
    </div>
  );
}

// ============================================================================
// Active Chip (selected state)
// ============================================================================

function ActiveRoleChip({ role, onDeselect }: { role: RoleOption; onDeselect: () => void }) {
  return (
    <button
      className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm font-medium text-white transition-all ${role.color} shadow-sm`}
      onClick={onDeselect}
    >
      <span>{role.icon}</span>
      {role.label}
    </button>
  );
}
